import classnames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import { Link } from 'react-router-dom'

import './BTTButton.scss'

/* eslint-disable complexity */
export const Button = ({
  text,
  href,
  title,
  className,
  type = 'primary',
  variant = '',
  size = 'default',
  icon = '',
  iconOnly = false,
  iconPosition = 'left',
  fullWidth = false,
  disabled = false,
  onClick = () => {},
  'aria-label': ariaLabel = '',
}) => {
  const iconButton = icon && iconOnly
  const classes = classnames(
    // Static classes
    'btt-button',
    // Conditional classes
    {
      [`btt-button--${type}`]: type,
      'btt-button--danger': variant === 'danger',
      'btt-button--sm': size === 'small',
      'btt-button--icon-only': iconButton,
      'btt-button--full-width': fullWidth,
      'btt-button--3d': variant === '3d',
      disabled,
    },
    className
  )

  let iconClasses = 'btt-button__icon'
  if (React.isValidElement(icon)) {
    iconClasses += ' icon'
    console.warn(
      'DEPRECATED: icons as React elements will not be supported in future releases'
    )
  } else {
    iconClasses += ' material-symbols-outlined'
  }

  const renderIcon = (position) =>
    icon &&
    iconPosition === position && <span className={iconClasses}>{icon}</span>

  const renderText = () =>
    text && !iconButton && <span className={'text'}>{text}</span>

  const content = (
    <>
      {renderIcon('left')}
      {renderText()}
      {renderIcon('right')}
    </>
  )

  if (href) {
    return (
      <Link
        className={classes}
        to={href}
        onClick={onClick}
        aria-label={ariaLabel}
      >
        {content}
      </Link>
    )
  }
  return (
    <button
      className={classes}
      title={title}
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
    >
      {content}
    </button>
  )
}

Button.propTypes = {
  type: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  href: PropTypes.string,
  onClick: PropTypes.func,
  text: PropTypes.string,
  iconOnly: PropTypes.bool,
  title: PropTypes.string,
  iconPosition: PropTypes.oneOf(['left', 'right']),
  size: PropTypes.oneOf(['default', 'small']), // added size prop
  'aria-label': PropTypes.string,
  variant: PropTypes.string,
  fullWidth: PropTypes.bool,
}

export default Button
